import { FC, useContext, useEffect } from "react";
// import Emptymiddleware from '../middlewares/Emptymiddleware'
import TokenMiddlewareTable from "./Tokenmiddleware";

import { TableInputProps } from "../Table";

import store from "../../../store/store";
import { removeBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import { GENERAL } from "../config/Transaction/ProductGeneralConf";
import { useSelector } from "react-redux";
import { fetchAllOrders } from "../reducer/orderSlice";
import OrderContext from "../memory/OrderContext";

const InitMiddlewareTable: FC<TableInputProps> = (props) => {
  const orderContext = useContext(OrderContext);
  const { categoryData } = useSelector(
    (state: any) => state.rootReducer.category
  );
  const { entityData, done } = useSelector((state: any) => state.DeletePopup);


  useEffect(() => {
    orderContext?.setPages({
      startPage: GENERAL.startPage,
    });
  }, []);

  useEffect(() => {
    store.dispatch(removeBreadcrumb());
  }, []);

  return <TokenMiddlewareTable {...props} />;
};

export default InitMiddlewareTable;
